import { render, staticRenderFns } from "./OverlapRelationOperationMode.vue?vue&type=template&id=673ef31a&scoped=true"
import script from "./OverlapRelationOperationMode.vue?vue&type=script&lang=js"
export * from "./OverlapRelationOperationMode.vue?vue&type=script&lang=js"
import style0 from "./OverlapRelationOperationMode.vue?vue&type=style&index=0&id=673ef31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ef31a",
  null
  
)

export default component.exports